import { Component, OnDestroy, OnInit } from '@angular/core';
import { Services } from '@ibexfusion/core-utils';
import { Models } from '@ibexfusion/models';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { EnvironmentService } from '@services/environment/environment.service';
import { MessengerService } from '@services/messenger/messenger.service';

/* these Services are injected by dynamicContentEntranceService */
import { PackageService } from '@services/packages/package.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { VotingResultService } from '@services/voting-result/voting-result.service';
import { GastroOrdersService } from '@services/gastro-orders/gastro-orders.service';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';

import * as _ from 'lodash';
import { FeedbackResultService } from '@services/feedback-result/feedback-result.service';
import { TranslateService } from '@services/translate/translate.service';
import { VoucherActivityService } from '@services/voucher-activity/voucher-activity.service';
import { MatDialog } from '@angular/material/dialog';
import { PreviewComponent } from '../../../components/preview/preview.component';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import moment from 'moment/moment';

declare const XLSX: any;

@Component({
  selector: 'app-dynamic-content-detail',
  templateUrl: './dynamic-content-detail.component.html',
  styleUrls: ['./dynamic-content-detail.component.scss'],
  providers: [DynamicContentService, DynamicContentEntranceService, PackageService, PackageInstalledAppsService,
    VotingResultService, GastroOrdersService, FrontProfilesService, FeedbackResultService, VoucherActivityService],
  standalone: false
})
export class DynamicContentDetailComponent implements OnInit, OnDestroy {

  routeSubscription: Subscription;
  routeQuerySubscription: Subscription;
  public title = 'Detail view';
  public subtitle: string;
  public pageActions: PageAction[];
  public entrance: Models.DynamicContentEntrance;
  public useWeekdays = false;

  public dynamicContent: Models.DynamicContentBase;
  public translationEntries = { en: {}, de: {}, fr: {}, it: {}, };
  languages = [];
  public isLoading = false;

  public type = '';
  public id = '';
  public parentId: string = null;
  public children = [];
  public files;
  public level;

  fileAssetPath: any;
  videoPath: any;
  imageAssetPath: any;
  timestamp = new Date().getTime();

  public isAlphabet = false;
  public allowChildren = true;

  public pageError = null;
  public votingResult: any = [];

  public barChartColors: Array<any> = [{ backgroundColor: 'rgba(54, 162, 235, 0.2)', borderColor: 'rgba(54, 162, 235, 1)', borderWidth: 2 }];
  public barChartOptions: any = { chart: { type: 'bar', height: 350, }, plotOptions: { bar: { horizontal: false } }, title: { text: 'Ergebnis', align: 'left', } };

  openHoursWeekKeys;
  openHoursWeekForm;
  openHoursExceptionDays;

  gastroOrders = [];
  gastroOrdersByMenu: any = {};
  gastroOrdersByMenuKeys: any;
  gastroOrdersByType: any = {};
  gastroOrderTypes = ['lunch', 'dinner', 'none'];
  childAllowingTypes = ['gastronomy', 'feedback'];

  voucherProfiles: any[];

  feedbacks = [];
  answersByQuestion = {};
  answersByQuestionKey = [];
  answersByQuestionnaire = [];
  questions = {};
  selectedTab = 0;
  public fromDate = new Date(new Date(Date.now() - 1000 * 60 * 60 * 24 * 28).setHours(0, 0, 0, 0));
  public toDate = new Date();
  public maxDate = this.toDate;
  translations;
  tab;
  packageId;
  previewPages = ['information', 'news', 'restaurant', 'opening-hours', 'event', 'gallery', 'social-media', 'accommodation'];

  constructor(
    public dynamicContentService: DynamicContentService, public votingResultService: VotingResultService, private dynamicContentEntranceService: DynamicContentEntranceService,
    private router: Router, private activatedRoute: ActivatedRoute, private location: Location, private environmentService: EnvironmentService, private translate: TranslateService,
    private dialog: MatDialog, private messengerService: MessengerService, private gastroOrderService: GastroOrdersService, private frontProfileService: FrontProfilesService,
    private feedbackResultService: FeedbackResultService, private voucher: VoucherActivityService, private contentPipeService: ContentPipeService
  ) {
    this.fileAssetPath = this.environmentService.getFileAssetPath();
    this.videoPath = this.environmentService.getVideoAssetPath();
    this.imageAssetPath = this.environmentService.getImageAssetPath();
  }

  ngOnInit() {
    this.translations = this.translate.get('system.dynamicContent');
    this.routeQuerySubscription = this.activatedRoute.queryParams.subscribe(queryParams => {
      this.parentId = queryParams['parentId'];
      this.tab = queryParams['tab'];
      this.packageId = queryParams['packageId'];
      if (this.packageId) {
        window['forcePackage'] = this.packageId;
      }
    });
    this.routeSubscription = this.activatedRoute.params.subscribe(params => {
      this.children = [];
      this.languages = [];
      this.type = params['type'];
      this.isAlphabet = this.type === 'alphabet';
      this.allowChildren = this.childAllowingTypes.includes(this.type);
      this.id = params['id'];
      this.getContent();
    });

  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.routeQuerySubscription) {
      this.routeQuerySubscription.unsubscribe();
    }
  }

  async getFeedback() {
    const tempToDate = _.clone(this.toDate);
    tempToDate.setDate(tempToDate.getDate() + 1);
    const feedbacks = await this.feedbackResultService.find(0, 100, { questionnaireId: this.dynamicContent._id });
    if (feedbacks?.data?.length) {
      this.feedbacks = feedbacks.data;
      for (let i = 0; i < this.feedbacks.length; i++) {
        if (this.feedbacks[i].answers && this.feedbacks[i].answers.length) {
          const answers = [];
          for (let a = 0; a < this.feedbacks[i].answers.length; a++) {
            const answer = this.feedbacks[i].answers[a];
            this.dynamicContentService.get(answer.questionId).then(question => {
              if (question && question.content) {
                this.questions[answer.questionId] = {
                  title: question.title, type: question.content.type, scaleMax: question.content.scaleMax, scaleMin: question.content.scaleMin,
                  scaleStep: question.content.scaleStep, answers: question.content.answers
                };
                if (!this.answersByQuestion.hasOwnProperty(answer.questionId)) {
                  this.answersByQuestion[answer.questionId] = [];
                }
                if (answer.stringValue && answer.stringValue[0]) {
                  this.answersByQuestion[answer.questionId].push(answer.stringValue);
                  answers.push({ answer: answer.stringValue.join(', '), questionId: answer.questionId, created: answer.created, type: question.content.type });
                }
                if (answer.numberValue) {
                  this.answersByQuestion[answer.questionId].push(answer.numberValue);
                  answers.push({ answer: answer.numberValue, questionId: answer.questionId, created: answer.created, type: question.content.type });
                }
              }
            });
          }
          this.answersByQuestionnaire.push(answers);
        }
      }
      setTimeout(() => { this.answersByQuestionKey = Object.keys(this.answersByQuestion); }, 1000);
    }
  }

  tabChanged(event) {
    this.selectedTab = event.index;
  }

  downloadFile() {
    const arrayForExport = [];
    if (+this.selectedTab === 0) {
      for (let i = 0; i < this.answersByQuestionnaire.length; i++) {
        const questionsKey = Object.keys(this.questions);
        const objectForExport: any = {};
        for (let q = 0; q < questionsKey.length; q++) {
          const answerIndex = this.answersByQuestionnaire[i].findIndex(el => el.questionId === questionsKey[q]);
          if (answerIndex !== -1) {
            objectForExport[this.questions[questionsKey[q]].title] = this.answersByQuestionnaire[i][answerIndex].answer;
          } else {
            objectForExport[this.questions[questionsKey[q]].title] = '';
          }
        }
        arrayForExport.push(objectForExport);
      }
    } else {
      const objectForExport: any = {};
      for (let i = 0; i < this.answersByQuestionnaire.length; i++) {
        let title = this.findEmail(this.answersByQuestionnaire[i]);
        if (!title) {
          const d = new Date(this.answersByQuestionnaire[i][0].created);
          title = d.getDate() + '.' + (d.getMonth() + 1) + '.' + d.getFullYear() + ' - ' +
            d.getHours() + '.' + d.getMinutes();
        }
        if (objectForExport.hasOwnProperty(title)) {
          title = i + '. ' + title;
        }
        const answers = this.answersByQuestionnaire[i].map(el => el.answer);
        objectForExport[title] = answers.join('\n- ');
      }
      arrayForExport.push(objectForExport);
    }

    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(arrayForExport[0]);
    const csv = arrayForExport.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' }), url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = 'export.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  findEmail(data) {
    if (data && data.length) {
      const emailIndex = data.findIndex(el => el.type === 'email');
      if (emailIndex !== -1) {
        return data[emailIndex].answer;
      }
    }
    return null;
  }

  async getContent(): Promise<any> {
    this.isLoading = true;
    this.dynamicContent = null;

    try {
      await this.checkParent({ _id: this.parentId });
    } catch (err) {
      this.pageError = err.message;
      this.isLoading = false;
      return
    }
    const dynamicContent = await this.dynamicContentService.find(0, 1, { _id: this.id, withSubs: true });
    dynamicContent['content'] = dynamicContent.data[0];
    const result = JSON.parse(JSON.stringify(dynamicContent));
    if (result.translations && result.translations.length) {
      for (const translationId of result.content.translationEntries) {
        for (const translation of result.translations) {
          if (translationId === translation._id) {
            this.translationEntries[translation.lang] = translation;
            this.languages.push(translation.lang);
          }
        }
      }
    }
    this.dynamicContent = result.content;
    this.dynamicContent['active'] = this.checkValid(this.dynamicContent);
    if (result.children && result.children.length) {
      this.initSubEntriesList(result.children);
    }
    if (this.type === 'feedback') {
      await this.getFeedback();
    }
    if (this.type === 'voting') {
      if (this.dynamicContent.content.type === 'multipleChoice' || this.dynamicContent.content.type === 'singleChoice') {
        this.votingResult = this.dynamicContent.content.answers.map(el => {
          return { answer: el, count: 0 };
        });
      } else if (this.dynamicContent.content.type === 'scale') {
        if (this.dynamicContent.content.scaleIcon !== 'numeric') {
          const scaleArr = Array(parseInt(this.dynamicContent.content.scaleMax, 10)).fill(1);
          this.votingResult = scaleArr.map((el, index) => {
            return { answer: index + 1, count: 0 };
          });
        } else {
          let value = +this.dynamicContent.content.scaleMin;
          while (value <= +this.dynamicContent.content.scaleMax) {
            this.votingResult.push({ answer: value, count: 0 });
            value = value + +this.dynamicContent.content.scaleStep;
          }
        }
      }
      this.getVotingResult(this.dynamicContent._id);
    }
    if (this.type === 'opening-hours' || this.type === 'restaurant') {
      if (this.dynamicContent.content.openingHours && this.dynamicContent.content.openingHours.regularOpeningHours && this.dynamicContent.content.exceptionDays) {
        this.openHoursWeekKeys = Object.keys(this.dynamicContent.content.openingHours.regularOpeningHours);
        this.openHoursWeekForm = this.dynamicContent.content.openingHours.regularOpeningHours;
        this.openHoursExceptionDays = this.dynamicContent.content.openingHours.exceptionDays;
      }
    }

    if (this.type === 'gastronomy' || this.type === 'gastronomy-checkout') {
      if (this.type === 'gastronomy') {
        this.gastroOrders = [];
        this.gastroOrdersByMenu = {};
        this.gastroOrdersByMenuKeys = [];
      }
      const gastroOrders = [];
      const orders = await this.gastroOrderService.find(0, 100, { gastroId: this.id });
      const profiles = await this.frontProfileService.find(0, 100, { FrontProfileID: { $in: orders.data.map(el => +el.profileId) } });
      for (const order of orders.data) {
        const frontProfile = _.find(profiles.data, profile => {
          return Services.HashIdService.unhashSingle(profile.FrontProfileID).toString() === order.profileId.toString()
        });
        gastroOrders.push(_.merge(order, frontProfile));
      }
      this.gastroOrders = gastroOrders;
      if (this.type === 'gastronomy') {
        for (const order of this.gastroOrders) {
          if (!this.gastroOrdersByMenu.hasOwnProperty(order.menuTitle)) {
            this.gastroOrdersByMenu[order.menuTitle] = [];
          }
          this.gastroOrdersByMenu[order.menuTitle].push(order);
        }
        this.gastroOrdersByMenuKeys = Object.keys(this.gastroOrdersByMenu);
      } else {
        this.gastroOrdersByType = _.groupBy(gastroOrders, 'menuType');
      }
    }

    if (this.type === 'voucher') {
      const vouchers = await this.voucher.find(0, 1000, { voucherId: this.id });
      const profiles = await this.frontProfileService.find(0, vouchers.data.length, { FrontProfileID: { $in: vouchers.data.map(el => +el.profileId) } });
      for (let i = 0; i < profiles.data?.length; i++) {
        profiles.data[i]['redeemed'] = vouchers.data.find(el => el.profileId === Services.HashIdService.unhashSingle(profiles.data[i].FrontProfileID).toString()).redeemed;
        profiles.data[i]['remembered'] = vouchers.data.find(el => el.profileId === Services.HashIdService.unhashSingle(profiles.data[i].FrontProfileID).toString()).remembered;
      }
      this.voucherProfiles = profiles.data;
    }

    this.createPageActions();
    this.isLoading = false;
  }

  async checkParent(query, level = 0): Promise<any> {
    if (level > 9) {
      return 'could not fetch dynamic content entrance to level: ' + level;
    }
    let result
    try {
      result = await this.dynamicContentEntranceService.getParent(query);
    } catch (err) {
      return err;
    }

    if (result.entrance && result.entrance.config && result.entrance.config.overwriteContentType) {
      result.entrance.type = result.entrance.config.overwriteContentType;
      this.type = result.entrance.config.overwriteContentType;
    }
    if (result.entrance && result.entrance.type && (result.entrance.type === 'activity' || result.entrance.type === 'gastronomy' || result.entrance.type === 'gastronomy-checkout')) {
      this.useWeekdays = true;
    }
    if (result.entrance) {
      if (!this.messengerService.checkContent(result.entrance._id)) {
        return Promise.reject({ message: 'You are not allowed to view this content' });
      }
      this.entrance = result.entrance;
      if (this.entrance && this.entrance.config && !!this.entrance.config.noChildren) {
        this.allowChildren = false;
      }
      this.level = level + 1;
      return true;
    } else if (result.content) {
      return this.checkParent({ $or: [{ _id: result.content._id }, { children: { $in: [result.content._id] } }] }, level + 1);
    }
  }

  initSubEntriesList(children) {
    this.children = [];
    children.map(child => {
      child['active'] = !!this.checkValid(child);
      this.children.push(child);
    });
    this.children.sort(function(obj1, obj2) {
      return obj1.order - obj2.order
    });

  }

  checkValid(content) {
    if (content) {
      const ibexPublishing = {
        published: content.published,
        weekdays: content.weekdaysInterval,
        publishstart: content.publishStart,
        publishfinish: content.publishEnd
      };
      if (content.dailyIntervalPublish) {
        ibexPublishing['timeframestart'] = content.dailyIntervalPublish.start;
        ibexPublishing['timeframefinish'] = content.dailyIntervalPublish.end;
      }
      return this.isValid(ibexPublishing);
    } else {
      return false;
    }
  }

  isValid(publishing) {
    const now = new Date();

    if (!this.weekdaysValid(publishing.weekdays)) {
      return false;
    }

    if (!publishing.publishstart && !publishing.publishfinish) {
      return true;
    }

    if (!!publishing.publishstart && moment(publishing.publishstart).toDate().getTime() > now.getTime()) {
      return false;
    }

    if (!!publishing.publishfinish && moment(publishing.publishfinish).toDate().getTime() < now.getTime()) {
      return false;
    }

    if (!!publishing.timeframestart) {
      const tfs = publishing.timeframestart.split(':');

      if (+tfs[0] > now.getHours()) {
        return false;
      }
      if (+tfs[0] === now.getHours() && +tfs[1] > now.getMinutes()) {
        return false;
      }
    }

    if (!!publishing.timeframefinish) {
      const tff = publishing.timeframefinish.split(':');

      if (+tff[0] < now.getHours()) {
        return false;
      }
      if (+tff[0] === now.getHours() && +tff[1] < now.getMinutes()) {
        return false;
      }
    }

    return true;
  }

  weekdaysValid(weekdays): boolean {
    if (weekdays === null || weekdays === undefined) {
      return true;
    }

    const days = [];
    if (!_.isArray(weekdays)) {
      weekdays = _.values(weekdays);
    }

    for (let i = 0; i < weekdays.length; i++) {
      days[weekdays[i]] = true;
    }

    return days[new Date().getDay()];
  }

  async getVotingResult(id) {
    const votingRes = await this.votingResultService.find(0, 10000, { votingId: id });
    if (votingRes?.data?.length) {
      if (this.dynamicContent.content.type !== 'scale') {
        votingRes.data.map(el => el.stringValue).flat().forEach(answer => {
          const item = this.votingResult.find(el => el.answer === answer);
          if (item) {
            item.count++;
          }
        })
      } else {
        votingRes.data.forEach(res => {
          const item = this.votingResult.find(el => +el.answer === +res.numberValue);
          if (item) {
            item.count++;
          }
        });
      }
    }
    if (this.votingResult.length) {
      this.barChartOptions.series = [{ data: this.votingResult.map(item => { return { x: item.answer, y: +item.count } }) }];
    }
  }

  downloadXLS() {
    let data;
    switch (this.type) {
      case 'gastronomy':
        data = [[this.formatDate(this.dynamicContent.content.date)], ['']]
        for (const menuKey of this.gastroOrdersByMenuKeys) {
          data.push([menuKey, this.gastroOrdersByMenu[menuKey].length]);
        }
        data.push(['', ''])
        for (const order of this.gastroOrders) {
          data.push([order.firstName + ' ' + order.lastName, order.menuTitle, this.formatTime(order.orderTime)]);
        }
        break;
      case 'gastronomy-checkout':
        data = [[this.formatDate(this.dynamicContent.content.date)], ['']]
        for (const type of this.gastroOrderTypes) {
          if (this.gastroOrdersByType[type]) {
            data.push([this.translations.gastroCheckout[type + 'Title']]);
            for (const order of this.gastroOrdersByType[type]) {
              data.push([order.firstName + ' ' + order.lastName]);
            }
            data.push(['']);
          }
        }
        break;
      case 'voucher':
        const header = [];
        for (const type of ['firstName', 'lastName'/*, 'remembered'*/, 'redeemed']) {
          header.push(this.translations.voucher[type + 'Title']);
        }
        data = [header];
        for (const profile of this.voucherProfiles) {
          data.push([
            profile.firstName, profile.lastName,
            /*(!!profile.remembered ? new Date(profile.remembered).toLocaleString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : 'Nicht gemerkt'),*/
            new Date(profile.redeemed).toLocaleString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
          ]);
        }
        break;
    }
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    XLSX.writeFile(workbook, this.type + '.xlsx');
  }

  formatDate(date: any) {
    date = new Date(date);
    const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    const month = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
    return day + '.' + month + '.' + date.getFullYear();
  }

  formatTime(date: any) {
    date = new Date(date);
    const hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
    const minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
    return hour + ':' + minute;
  }

  openPreview() {
    const data = this.contentPipeService.getTransformedEntry(this.dynamicContent, this.entrance);
    const result = this.dialog.open(PreviewComponent, <any>{
      width: '100%', height: '100%', panelClass: 'preview-modal', data: data
    }).afterClosed().toPromise();
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Back',
        translationString: 'general.back',
        callback: () => {
          this.location.back();
        }
      })
    ];
    if ((!!this.entrance && !this.entrance.readonly) || !this.entrance) {
      this.pageActions.push(new PageAction({
        icon: 'edit',
        title: 'Edit',
        translationString: 'general.edit',
        callback: () => {
          this.router.navigate(['dynamic-content', this.type, this.id, 'edit'], { queryParams: { parentId: this.parentId } });
        }
      }));
    }
    if (!!this.entrance && window['forcePackage'] && this.showPreviewPages()) {
      this.pageActions.push(new PageAction({
        icon: 'preview',
        title: 'Preview',
        translationString: 'general.preview',
        callback: () => {
          this.openPreview();
        }
      }));
    }
  }

  showPreviewPages() {
    if (this.previewPages.indexOf(this.entrance.type) !== -1 ||
      (this.entrance && this.entrance.config && this.entrance.config.overwriteContentType &&
        this.previewPages.indexOf(this.entrance.config.overwriteContentType) !== -1)) {
      return true;
    } else {
      return false;
    }
  }
}
